import React from "react";
import { useRouteMatch } from "react-router-dom";

import Menu from "../../../core/Menu";

import { BATCH_TYPE_KEYS } from "frontend/components/fort/mod/photos/constants.js";

const PhotoModHomeMenu = () => {
    const { url } = useRouteMatch();

    return (
        <>
            <Menu
                menuGroups={[
                    {
                        groupName: "Visual Moderation",
                        groupId: "1",
                        groupItems: [
                            {
                                id: "1",
                                text: "My Batches",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.MY_BATCHES}=true`
                            },
                            {
                                id: "2",
                                text: "Unassigned Batches",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.UNASSIGNED}=true`
                            },
                            {
                                id: "3",
                                text: "No Flags in Batch",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.NO_FLAGS}=true`
                            },
                            {
                                id: "4",
                                text: "Release & Editorial Flags",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.REL_EUO}=true`
                            },
                            {
                                id: "5",
                                text: "Explicit & Text Flags",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.EXP_TXT}=true`
                            },
                            {
                                id: "6",
                                text: "Saved for Later in Batch",
                                href: `${url}/visual-queue/?${BATCH_TYPE_KEYS.SAVED}=true`
                            },
                            {
                                id: "7",
                                text: "All Batches",
                                href: `${url}/visual-queue/`
                            }
                        ]
                    },
                    {
                        groupName: "Admin Links",
                        groupId: "2",
                        groupItems: [
                            {
                                id: "1",
                                text: "Completed Batches",
                                href: `${url}/completed-queue/`
                            }
                            // hiding suspended queue for scope reduction
                            // will be reinstating at a later time
                            // {
                            //     id: "2",
                            //     text: "Suspended Batches",
                            //     href: `${url}/suspended-queue/`
                            // }
                        ]
                    }
                ]}
            />
        </>
    );
};

export default PhotoModHomeMenu;
